type QuotationFeeLike = {
  NoUnits?: number | string | null;
  StructuralFee?: number | string | null;
  Structural?: number | string | null;
  CivilFee?: number | string | null;
  SoilReportFee?: number | string | null;
  SubTotal?: number | string | null;
  QuotationAmount?: number | string | null;
};

function asNumber(value: unknown): number | null {
  if (value === null || value === undefined) return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  const parsed = Number(String(value).trim());
  return Number.isFinite(parsed) ? parsed : null;
}

export function getQuotationUnits(record: QuotationFeeLike): number {
  const units = asNumber(record?.NoUnits);
  return units && units > 0 ? Math.trunc(units) : 1;
}

export function getQuotationStructuralFeePerUnit(record: QuotationFeeLike): number {
  return asNumber(record?.StructuralFee) ?? 0;
}

export function getQuotationStructuralFeeTotal(record: QuotationFeeLike): number {
  const storedTotal = asNumber(record?.Structural);
  if (storedTotal !== null && storedTotal > 0) {
    return storedTotal;
  }

  const perUnit = getQuotationStructuralFeePerUnit(record);
  const units = getQuotationUnits(record);
  return perUnit * units;
}

export function getQuotationCivilFee(record: QuotationFeeLike): number {
  return asNumber(record?.CivilFee) ?? 0;
}

export function getQuotationSoilReportFee(record: QuotationFeeLike): number {
  return asNumber(record?.SoilReportFee) ?? 0;
}

export function getQuotationDesignFeeTotal(record: QuotationFeeLike): number {
  return getQuotationStructuralFeeTotal(record) + getQuotationCivilFee(record);
}

export function getQuotationDisplayAmount(record: QuotationFeeLike): number {
  const subTotal = asNumber(record?.SubTotal);
  if (subTotal !== null && subTotal > 0) {
    return subTotal;
  }

  const quotationAmount = asNumber(record?.QuotationAmount);
  if (quotationAmount !== null && quotationAmount > 0) {
    return quotationAmount;
  }

  return getQuotationStructuralFeeTotal(record) + getQuotationCivilFee(record) + getQuotationSoilReportFee(record);
}
